import _lib from '../_lib';
import active from './active/index';
import {DirectivesNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'directives';
  let activations = [
    {
      name: 'directives',
      test: api.messageIs(DirectivesNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};